import { render } from "./MandateItem.vue?vue&type=template&id=577d9871&scoped=true"
import script from "./MandateItem.vue?vue&type=script&lang=js"
export * from "./MandateItem.vue?vue&type=script&lang=js"

import "./MandateItem.vue?vue&type=style&index=0&id=577d9871&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577d9871"]])

export default __exports__